<template>
	<div class="page">
		<van-nav-bar :title="$t('concubine.concubine')" class="nav-bar">
			<template #left>
				<van-icon name="arrow-left" color="#fff" @click="back()" />
			</template>
		</van-nav-bar>
		<div class="movie-video" v-if="hasVideo">
			<video id="my-video" class="video-js" playsinline>
			</video>
		</div>
		<div class="card" v-if="xuanfeidata.xuanfei_name">
			{{ xuanfeidata.xuanfei_name }}
		</div>
		<div class="box">
			<van-image width="98%" fit="contain" height="100%" v-for="(v, k) in xuanfeidata.img_url" :key="k"
				:src="v" />
			<van-button round="true" @click="yuyue" class="button">{{ $t("Universal.match") }}</van-button>
		</div>
	</div>
</template>

<script>
import videojs from "video.js";
import "videojs-contrib-hls";
export default {
	data() {
		return {
			xuanfeidata: {
				img_url: [],
				video_url: ''
			},
			player: null
		};
	},
	computed: {
		hasVideo() {
			return !!(this.xuanfeidata && this.xuanfeidata.video_url);
		}
	},
	methods: {
		back() {
			this.$router.back()
		},
		getxuanfeidata() {
			this.$http({
				method: 'get',
				url: 'xuanfeidata',
				data: { id: this.$route.query.id }
			}).then(res => {
				this.xuanfeidata = res.data || { img_url: [], video_url: '' };
				this.initPlayer(this.xuanfeidata.video_url || '');
			})
		},
		initPlayer(src) {
			if (!src) {
				this.disposePlayer();
				return;
			}
			this.$nextTick(() => {
				if (!this.player) {
					this.player = videojs('my-video', {
						height: "200px",
						preload: "auto",
						controls: true,
						multipleArray: [0.75, 1, 1.5, 2],
					});
				}
				this.player.src([{ src }]);
			});
		},
		disposePlayer() {
			if (this.player) {
				this.player.dispose();
				this.player = null;
			}
		},
		yuyue() {
			this.$toast(this.$t("reservation.counselor"));
		}
	},
	mounted() {
		this.getxuanfeidata();
	},
	destroyed() {
		this.disposePlayer();
	}
};
</script>

<style lang="less" scoped>
@import "@/assets/css/base.less";

.video-js {
	width: 100%;
	height: 140vw;
	font-size: 24px;
}

::v-deep .movie-video .video-js .vjs-big-play-button {
	top: 50%;
	left: 50%;
	margin-top: -50px;
	margin-left: -100px;
}

.content {
	color: @white;

	p {
		margin: .5em 0;
	}

	.score {
		color: @theme2;
	}
}

.card {
	margin: @md1;
	padding: @pd1;
	border: 1px solid @theme2;
	border-radius: @br1;
	color: @white;
}

.container {
	display: inline-block;
}

.box {
	width: 95%;
	margin: 0 auto;
	text-align: center;
	padding-bottom: 6.25rem;
}

.name {
	font-size: 1.125rem;
}

.title {
	font-size: 0.625rem;
}

.button {
	width: 60vw;
	height: 2.5rem;
	font-size: 0.9375rem;
	margin-top: 0.625rem;
}
</style>
